import PropTypes from 'prop-types';
import { US_TERRITORIES } from 'assets/countries';
import { Container, Point, GreenCircle, YellowCircle, RedCircle } from './styled';

const CoveragePoint = ({ color, children }) => {
  return (
    <Point>
      {color === 'green' && <GreenCircle />}
      {color === 'yellow' && <YellowCircle />}
      {color === 'red' && <RedCircle />}
      <div>{children}</div>
    </Point>
  );
};

CoveragePoint.propTypes = {
  color: PropTypes.string,
  children: PropTypes.node
};

const CountryCoverageDetails = ({ coverageCountry, travelOnly, addOn, sanctioned }) => {
  const { name } = coverageCountry;

  const getContent = () => {
    if (addOn) {
      if (US_TERRITORIES.includes(coverageCountry.code)) {
        return (
          <>
            <CoveragePoint color="red">We can not cover US residents</CoveragePoint>
            <CoveragePoint color="green">
              With the base plan, United States has emergency coverage for up to 30 day
              trips there
            </CoveragePoint>
            <CoveragePoint color="green">
              For non-US residents who visit frequently, coverage in the United States is
              available for up to 6 months at a higher price
            </CoveragePoint>
          </>
        );
      }

      return (
        <>
          <CoveragePoint color="green">
            {name} has emergency coverage for up to 30 day trips there
          </CoveragePoint>
          <CoveragePoint color="green">
            {name} is covered as the country of residence*
          </CoveragePoint>
          <div>*Full coverage for members in {name} comes at an extra price.</div>
        </>
      );
    }

    if (sanctioned) {
      return (
        <CoveragePoint color="red">
          {name} is not covered as your country of residence. We can not arrange for
          direct billing with hospitals in {name}.
        </CoveragePoint>
      );
    }

    if (travelOnly) {
      return (
        <>
          <CoveragePoint color="green">
            {name} is covered for long or short trips there
          </CoveragePoint>
          <CoveragePoint color="red">
            {name} is not covered as the country of residence
          </CoveragePoint>
        </>
      );
    }

    return (
      <CoveragePoint color="green">
        {name} is included in your global coverage.
      </CoveragePoint>
    );
  };

  return <Container>{getContent()}</Container>;
};

CountryCoverageDetails.propTypes = {
  coverageCountry: PropTypes.shape({
    name: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired
  }).isRequired,
  travelOnly: PropTypes.bool.isRequired,
  addOn: PropTypes.bool.isRequired,
  sanctioned: PropTypes.bool.isRequired
};

export default CountryCoverageDetails;
